export enum Options {
  YES = 'YES',
  NO = 'NO',
}
